import axios from "axios";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

const ViewSignedDoc = () => {
  const [searchParams] = useSearchParams();
  const [pdfSrc, setPdfSrc] = useState("");

  useEffect(() => {
    const encryptedId = searchParams.get("base64");
    if (encryptedId) {
      axios
        .get(
          `https://esign.eregistrationukgov.in/Home/GetPdf?encId=${encodeURIComponent(
            encryptedId
          )}`
        )
        .then((res) => {
          if (res.data.base64) {
            setPdfSrc(`data:application/pdf;base64,${res.data.base64}`);
          } else {
            console.error("No PDF found");
          }
        })
        .catch((err) => console.error("Error fetching PDF:", err));
    }
  }, [searchParams]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="border-2 border-solid p-4 mb-4 bg-green-500 text-white ">
        <h2 className="text-xl font-semibold mb-4 text-success">
          You have sucessfully Signed the Document
        </h2>
      </div>
      {pdfSrc ? (
        <iframe
          src={pdfSrc}
          title="PDF Viewer"
          className="w-full max-w-7xl h-[90vh] border shadow-lg"
        ></iframe>
      ) : (
        <p className="text-gray-600">Loading PDF...</p>
      )}
    </div>
  );
};
{
  /* <iframe
src={pdfSrc}
title="PDF Viewer"
className="w-full max-w-7xl h-[90vh] border shadow-lg"
></iframe> */
}
export default ViewSignedDoc;
